import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Image,
  Text,
  VStack,
  HStack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  IconButton,
  Flex,
  Heading,
  Button,
  Alert,
  AlertIcon,
  Spacer,
  Input,
  Checkbox,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  FormControl,
  FormLabel,
  Textarea,
  useDisclosure,
  Center,
  Spinner,
  Badge,
} from "@chakra-ui/react";
import { ArrowBackIcon, AddIcon, DeleteIcon } from "@chakra-ui/icons";
import { useParams, useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabaseClient";
import { useAuth } from "../context/AuthContext";
import MusicianModal from "../components/modals/MusicianModal";
import TrackModal from "../components/modals/TrackModal";
import TrackEditModal from "../components/modals/TrackEditModal";
import SendEmail from "../components/SendEmail";

const GENRES = [
  { value: "트로트", label: "트로트" },
  { value: "Ballad (국내)", label: "발라드 (국내)" },
  { value: "Blues (국내)", label: "블루스 (국내)" },
  { value: "Dance (국내)", label: "댄스 (국내)" },
  { value: "Folk (국내)", label: "포크 (국내)" },
  { value: "R&B / Soul (국내)", label: "알앤비 / 소울 (국내)" },
  { value: "Rap / Hip-hop (국내)", label: "랩 / 힙합 (국내)" },
  { value: "Rock (국내)", label: "록 (국내)" },
  { value: "Electronica (국내)", label: "일렉트로니카 (국내)" },
  { value: "CCM (국내)", label: "CCM (국내)" },
  { value: "Jazz (국내)", label: "재즈 (국내)" },
  { value: "OST (국내)", label: "OST (국내)" },
  { value: "Blues (국외)", label: "블루스 (국외)" },
  { value: "Country (국외)", label: "컨트리 (국외)" },
  { value: "Electronica (국외)", label: "일렉트로니카 (국외)" },
  { value: "Folk (국외)", label: "포크 (국외)" },
  { value: "Pop (국외)", label: "팝 (국외)" },
  { value: "EDM (국외)", label: "EDM (국외)" },
  { value: "R&B / Soul (국외)", label: "알앤비 / 소울 (국외)" },
  { value: "Rap / Hip-hop (국외)", label: "랩 / 힙합 (국외)" },
  { value: "Rock (국외)", label: "록 (국외)" },
  { value: "CCM (국외)", label: "CCM (국외)" },
  { value: "Jazz (국외)", label: "재즈 (국외)" },
  { value: "OST (국외)", label: "OST (국외)" },
  { value: "한국전통음악", label: "한국전통음악" },
  { value: "어린이음악", label: "어린이음악" },
  { value: "종교음악", label: "종교음악" },
  { value: "Classic", label: "클래식" },
  { value: "New Age", label: "뉴에이지" },
  { value: "뮤직테라피", label: "뮤직테라피" },
  { value: "기타", label: "기타" },
  { value: "월드뮤직", label: "월드뮤직" },
  { value: "Electronica (J-Pop)", label: "일렉트로니카 (J-Pop)" },
  { value: "Pop (J-Pop)", label: "팝 (J-Pop)" },
  { value: "R&B / Soul (J-Pop)", label: "알앤비 / 소울 (J-Pop)" },
  { value: "Rap / Hip-hop (J-Pop)", label: "랩 / 힙합 (J-Pop)" },
  { value: "Rock (J-Pop)", label: "록 (J-Pop)" },
];
const MOODS = [
  { value: "Angry", label: "화난" },
  { value: "Busy & Frantic", label: "광란&들뜬" },
  { value: "Changing Tempo", label: "다이내믹 템포" },
  { value: "Chasing", label: "추적" },
  { value: "Dark", label: "어둠" },
  { value: "Dreamy", label: "몽환" },
  { value: "Eccentric", label: "괴짜" },
  { value: "Elegant", label: "우아함" },
  { value: "Epic", label: "웅장" },
  { value: "Euphoric", label: "유쾌" },
  { value: "Fear", label: "두려움" },
  { value: "Floating", label: "떠있는 느낌" },
  { value: "Funny", label: "코믹" },
  { value: "Glamorous", label: "화려함" },
  { value: "Happy", label: "행복" },
  { value: "Heavy & Ponderous", label: "무게감" },
  { value: "Hopeful", label: "희망" },
  { value: "Laid Back", label: "여유" },
  { value: "Marching", label: "행진" },
  { value: "Mysterious", label: "미스테리" },
  { value: "Peaceful", label: "평화로움" },
  { value: "Quirky", label: "별난" },
  { value: "Relaxing", label: "편안함" },
  { value: "Restless", label: "불안정함" },
  { value: "Romantic", label: "로맨틱" },
  { value: "Running", label: "운동" },
  { value: "Sad", label: "슬픔" },
  { value: "Scary", label: "무서움" },
  { value: "Sentimental", label: "감상적임" },
  { value: "Sexy", label: "섹시" },
  { value: "Smooth", label: "부드러움" },
  { value: "Sneaking", label: "은밀함" },
  { value: "Suspense", label: "긴장감" },
  { value: "Weird", label: "기묘함" },
  { value: "All moods", label: "전체 무드" },
];

const AlbumDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const toast = useToast();
  const [albumData, setAlbumData] = useState(null);
  const [tracks, setTracks] = useState([]);
  const [musician, setMusician] = useState(null);
  const [label, setLabel] = useState(null);
  const [promoCode, setPromoCode] = useState("");
  const [isMusicianModalOpen, setIsMusicianModalOpen] = useState(false);
  const [agreements, setAgreements] = useState({
    copyright: false,
    terms: false,
  });
  const [isTrackModalOpen, setIsTrackModalOpen] = useState(false);
  const [musicians, setMusicians] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isDraft, setIsDraft] = useState(false);
  const [isOwned, setIsOwned] = useState(false);
  const [requestContent, setRequestContent] = useState("");
  const [requestFile, setRequestFile] = useState(null);
  const [isTrackEditModalOpen, setIsTrackEditModalOpen] = useState(false);
  const [selectedTrack, setSelectedTrack] = useState(null);
  const [isRegistering, setIsRegistering] = useState(false);

  const {
    isOpen: isReferralModalOpen,
    onOpen: onReferralModalOpen,
    onClose: onReferralModalClose,
  } = useDisclosure();

  const {
    isOpen: isRequestModalOpen,
    onOpen: onRequestModalOpen,
    onClose: onRequestModalClose,
  } = useDisclosure();

  const fetchMusicians = async (musicianId) => {
    try {
      const { data, error } = await supabase
        .from("musician")
        .select("*")
        .eq("id", musicianId)
        .single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error("Error fetching musician:", error);
      return null;
    }
  };

  const fetchAlbumData = async () => {
    try {
      // 1. 앨범 정보 가져오기
      const { data: album, error: albumError } = await supabase
        .from("album")
        .select("*")
        .eq("id", id)
        .single();

      if (albumError) throw albumError;
      setAlbumData(album);

      // 2. 트랙 정보 가져오기
      const { data: trackData, error: trackError } = await supabase
        .from("track")
        .select("*")
        .eq("album", album.id)
        .order("track_number", { ascending: true });

      if (trackError) throw trackError;
      // trackNumber를 숫자로 변환하여 정렬
      const sortedTracks = trackData.sort(
        (a, b) => Number(a.track_number) - Number(b.track_number)
      );
      setTracks(sortedTracks);

      // 3. 뮤지션 정보 가져오기
      if (album.musician) {
        // musicians 필드가 문자열인 경우 배열로 변환
        const musicianIds =
          typeof album.musician === "string"
            ? [album.musician]
            : Array.isArray(album.musician)
            ? album.musician
            : [];

        const musicianPromises = musicianIds.map(fetchMusicians);
        const musicianResults = await Promise.all(musicianPromises);
        const validMusicians = musicianResults.filter((m) => m !== null);

        setMusicians(validMusicians);
        if (validMusicians.length > 0) {
          setMusician(validMusicians[0]);
        }
      }

      // 4. 레이블 정보 가져오기
      if (album.label) {
        const { data: labelData, error: labelError } = await supabase
          .from("label")
          .select("*")
          .eq("id", album.label)
          .single();

        if (labelError) throw labelError;
        setLabel(labelData);
      }

      setIsDraft(album.status_musician === "[뮤지션] 작성중");
      setIsOwned(album.status_musician !== "[뮤지션] 작성중");
    } catch (error) {
      console.error("Error fetching album data:", error);
      //navigate("/");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAlbumData();
  }, [id]);

  const handleMusicianAdd = async (newMusician) => {
    try {
      // 앨범의 musicians 배열에 새로운 뮤지션 ID 추가
      const updatedMusicians = [...(albumData.musicians || []), newMusician.id];

      const { error } = await supabase
        .from("album")
        .update({ musicians: updatedMusicians })
        .eq("id", id);

      if (error) throw error;

      // 뮤지션 목록 새로고침
      const { data: musicianData, error: musicianError } = await supabase
        .from("musician")
        .select("*")
        .eq("id", newMusician.id)
        .single();

      if (musicianError) throw musicianError;
      setMusician(musicianData);

      toast({
        title: "뮤지션 추가 성공",
        description: "뮤지션이 성공적으로 추가되었습니다.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error adding musician:", error);
      toast({
        title: "뮤지션 추가 실패",
        description: "뮤지션 추가 중 오류가 발생했습니다.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const refreshTracks = async () => {
    try {
      const { data: trackData, error: trackError } = await supabase
        .from("track")
        .select("*")
        .eq("album", id)
        .order("track_number", { ascending: true });

      if (trackError) throw trackError;
      setTracks(trackData);
    } catch (error) {
      console.error("Error fetching tracks:", error);
    }
  };

  const handleFinalRegistration = async () => {
    try {
      setIsRegistering(true);
      const { error } = await supabase
        .from("album")
        .update({
          status_musician: "[뮤지션] 등록 완료",
          agree_distribution: "TRUE",
          agree_copyrights: "TRUE",
          agree_legal: "TRUE",
          referral: promoCode,
          modified_date: new Date().toISOString(),
        })
        .eq("id", id);

      if (error) throw error;

      // ownership 테이블에 데이터 저장
      for (const track of tracks) {
        const { data: ownershipData, error: ownershipError } = await supabase
          .from("ownership")
          .insert({
            ownership_user: user.email,
            ownership_share: 100,
            track_code: track.id,
            name_album: albumData.name_album_kr,
            name_track: track.track_name_kr,
            name_musician: musician?.name_musician || "미정",
            ownership_label: label?.id || null,
            agree_playlist: "TRUE",
            agree_legal: "TRUE",
            agree_copyrights: "TRUE",
            agree_laeebly_for_shorts: "FALSE",
          })
          .select()
          .single();
        if (ownershipError) throw ownershipError;
      }

      // 이메일 전송
      const albumInfo = `
<p>사용자 이메일: ${user.email}</p>
<p>앨범명: ${albumData.name_album_kr}</p>
<p>뮤지션: ${musician?.name_musician || "미정"}</p>
<p>레이블: ${label?.name || "미정"}</p>
<p>등록일: ${new Date().toLocaleDateString("ko-KR")}</p>
<p>추천인 코드: ${promoCode || "없음"}</p>

<p>트랙 목록:</p>
${tracks
  .map(
    (track, index) => `
${index + 1}. ${track.track_name_kr}
<p> - ISRC: ${track.isrc}</p>
<p> - 길이: ${track.running_time_sec}초</p>
<p> - 장르: ${track.mood}</p>
`
  )
  .join("")}
      `.trim();

      await SendEmail({
        email: "contact@plpl.kr",
        ccEmails: user?.email ? [user.email] : [],
        subject: `[등록] 앨범 최종 신청 / ${albumData.name_album_kr}`,
        message: albumInfo,
      });

      toast({
        title: "앨범이 최종 등록되었습니다.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      navigate("/release");
    } catch (error) {
      console.error("앨범 등록 중 오류 발생:", error);
      toast({
        title: "앨범 등록에 실패했습니다.",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsRegistering(false);
    }
  };

  const handleRequestSubmit = async () => {
    try {
      // 파일 업로드
      let fileUrl = null;
      let attachments = [];
      if (requestFile) {
        const fileExt = requestFile.name.split(".").pop();
        const fileName = `${id}_request_${Date.now()}.${fileExt}`;
        const { data: uploadData, error: uploadError } = await supabase.storage
          .from("modify")
          .upload(fileName, requestFile);

        if (uploadError) throw uploadError;

        // 업로드된 파일의 public URL 가져오기
        const {
          data: { publicUrl },
        } = supabase.storage.from("modify").getPublicUrl(fileName);

        fileUrl = publicUrl;
        attachments.push({
          path: fileUrl,
          filename: fileName,
        });
      }

      // 이메일 전송
      await SendEmail({
        email: "contact@plpl.kr",
        ccEmails: user?.email ? [user.email] : [],
        subject: `[접수] 앨범 수정 요청 / ${albumData.name_album_kr}`,
        message: `
<p>사용자 이메일: ${user.email}</p>
<p>앨범명: ${albumData.name_album_kr}</p>
<p></p>
<p>요청 내용:</p> 
<p>${requestContent}</p>`,
        attachments,
        storageBucket: "modify",
      });

      // 이메일 전송을 위한 데이터 저장
      const { error: requestError } = await supabase
        .from("modification_requests")
        .insert({
          album_id: id,
          content: requestContent,
          file_url: fileUrl,
          status: "pending",
        });

      if (requestError) throw requestError;

      toast({
        title: "수정 요청이 제출되었습니다.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      onRequestModalClose();
    } catch (error) {
      console.error("수정 요청 제출 중 오류 발생:", error);
      toast({
        title: "수정 요청 제출에 실패했습니다.",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const formatDuration = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  const hasTitleTrack = tracks.some(
    (track) => track.track_main && track.track_main.toLowerCase() === "true"
  );

  // 트랙 삭제 함수
  const handleDeleteTrack = async (trackId) => {
    try {
      const { error } = await supabase.from("track").delete().eq("id", trackId);
      if (error) throw error;
      toast({
        title: "트랙이 삭제되었습니다.",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
      // 트랙 목록 새로고침
      refreshTracks();
    } catch (error) {
      toast({
        title: "트랙 삭제 실패",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  if (isLoading) {
    return (
      <Container maxW="container.xl" py={8}>
        <Center py={10}>
          <Spinner size="xl" />
        </Center>
      </Container>
    );
  }

  if (!albumData) {
    return <Box>앨범을 찾을 수 없습니다.</Box>;
  }

  return (
    <Container maxW="container.xl" py={8}>
      <IconButton
        icon={<ArrowBackIcon />}
        onClick={() => navigate(-1)}
        mb={4}
        aria-label="Go back"
        variant="ghost"
      />

      <Flex direction={{ base: "column", md: "row" }} gap={8} mb={8}>
        {/* 왼쪽: 앨범 커버 */}
        <Box flex={1} maxW="400px">
          <Image
            src={albumData.cover || undefined}
            alt={albumData.name_album_kr}
            borderRadius="lg"
            w="full"
            fallbackSrc="data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='400' height='400'><rect width='100%' height='100%' fill='white'/></svg>"
          />
        </Box>

        {/* 오른쪽: 앨범 정보 */}
        <VStack flex={2} align="start" spacing={8}>
          <Heading size="xl">{albumData.name_album_kr}</Heading>

          {musician && (
            <HStack width="100%" spacing={4}>
              <HStack spacing={4}>
                <Image
                  src={musician.image_profile}
                  alt={musician.name_musician}
                  boxSize="40px"
                  borderRadius="full"
                  fallbackSrc="data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='32' height='32'><rect width='100%' height='100%' fill='white'/></svg>"
                />
                <Text fontSize="lg">{musician.name_musician}</Text>
              </HStack>
              <Spacer />
              {/* <Button
                leftIcon={<AddIcon />}
                size="md"
                colorScheme="blue"
                variant="ghost"
                onClick={() => setIsMusicianModalOpen(true)}
              >
                뮤지션 추가
              </Button> */}
            </HStack>
          )}

          {label && (
            <HStack spacing={4}>
              <Image
                src={label.logo}
                alt={label.name}
                boxSize="40px"
                borderRadius="full"
                fallbackSrc="data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='32' height='32'><rect width='100%' height='100%' fill='white'/></svg>"
              />
              <Text fontSize="lg">{label.name}</Text>
            </HStack>
          )}

          <Text fontSize="lg" color="gray.600">
            등록일:{" "}
            {new Date(albumData.registered_at).toLocaleDateString("ko-KR")}
          </Text>
        </VStack>
      </Flex>

      {/* 앨범 소개 */}
      <Box mb={8}>
        <Heading size="md" mb={4}>
          앨범 소개
        </Heading>
        <Box whiteSpace="pre-line">
          {albumData.description || "앨범 소개가 없습니다."}
        </Box>
      </Box>

      {/* 트랙 리스트 */}
      <Box mb={20}>
        <Flex align="center" mb={4}>
          <Heading size="md">트랙 리스트</Heading>
          <Spacer />
          {isDraft && (
            <Button
              leftIcon={<AddIcon />}
              colorScheme="blue"
              size="sm"
              onClick={() => setIsTrackModalOpen(true)}
            >
              트랙 추가
            </Button>
          )}
        </Flex>
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>#</Th>
              <Th>타이틀</Th>
              <Th>제목</Th>
              <Th>ISRC</Th>
              <Th>길이</Th>
              <Th display={{ base: "none", md: "table-cell" }}>장르</Th>
              <Th display={{ base: "none", md: "table-cell" }}>분위기</Th>
              <Th></Th>
            </Tr>
          </Thead>
          <Tbody>
            {tracks.map((track) => (
              <Tr
                key={track.id}
                onClick={
                  isOwned
                    ? undefined
                    : () => {
                        setSelectedTrack(track);
                        setIsTrackEditModalOpen(true);
                      }
                }
                style={{ cursor: isOwned ? "default" : "pointer" }}
              >
                <Td>{track.track_number}</Td>
                <Td>
                  {track.track_main && track.track_main.toLowerCase() === "true"
                    ? "✔️"
                    : ""}
                </Td>
                <Td>
                  <Text>{track.track_name_kr}</Text>
                  {track.track_name_en && (
                    <Text fontSize="sm" color="gray.500">
                      {track.track_name_en}
                    </Text>
                  )}
                </Td>
                <Td>
                  {track.isrc && track.isrc !== "해외 발매 X"
                    ? track.isrc
                    : "-"}
                </Td>
                <Td>{formatDuration(track.running_time_sec)}</Td>
                <Td display={{ base: "none", md: "table-cell" }}>
                  {typeof track.genre_depth4 === "string" &&
                  track.genre_depth4.trim() !== "" ? (
                    <Badge
                      colorScheme="blue"
                      variant="subtle"
                      borderRadius="full"
                      px={3}
                      py={1}
                      mr={1}
                      mb={1}
                      fontSize="sm"
                    >
                      {track.genre_depth4}
                    </Badge>
                  ) : null}
                </Td>
                <Td display={{ base: "none", md: "table-cell" }}>
                  {typeof track.mood === "string"
                    ? track.mood
                        .replace(/[[\]"']/g, "")
                        .split(/,|\//)
                        .filter((word) => word.trim() !== "")
                        .map((word, idx) => {
                          const mood = MOODS.find(
                            (m) => m.value === word.trim()
                          );
                          return (
                            <Badge
                              key={idx}
                              colorScheme="purple"
                              variant="solid"
                              borderRadius="full"
                              px={3}
                              py={1}
                              mr={1}
                              mb={1}
                              fontSize="sm"
                            >
                              {mood ? mood.label : word}
                            </Badge>
                          );
                        })
                    : null}
                </Td>
                <Td>
                  {!isOwned && (
                    <IconButton
                      icon={<DeleteIcon />}
                      aria-label="트랙 삭제"
                      colorScheme="red"
                      variant="ghost"
                      size="sm"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteTrack(track.id);
                      }}
                    />
                  )}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
        {/* 타이틀 곡이 없을 때 경고 문구 (isOwned가 아닐 때만) */}
        {!isOwned && !hasTitleTrack && (
          <Box mt={4}>
            <Alert status="warning" borderRadius="md">
              <AlertIcon />
              최소 1개의 타이틀 곡 지정이 필요합니다.
            </Alert>
          </Box>
        )}
      </Box>

      {/* 동의사항 (작성중인 앨범일 때만 표시) */}
      {isDraft && (
        <VStack spacing={3} mb={8}>
          <Alert status="info" borderRadius="md">
            <AlertIcon />
            <Checkbox
              isChecked={agreements.copyright}
              onChange={(e) =>
                setAgreements({ ...agreements, copyright: e.target.checked })
              }
              colorScheme="blue"
              sx={{
                ".chakra-checkbox__control": {
                  borderColor: "blue.600",
                  boxShadow: "0 0 0 1px #2563eb",
                },
              }}
            >
              [필수] 위 등록한 저작물의 적법한 권리를 보유하고 있습니다. 타인의
              저작물을 침해로 인해 법적 분쟁이 발생할 경우, 법적 책임은 회원에게
              있음을 동의합니다.
            </Checkbox>
          </Alert>
          <Alert status="info" borderRadius="md">
            <AlertIcon />
            <Checkbox
              isChecked={agreements.terms}
              onChange={(e) =>
                setAgreements({ ...agreements, terms: e.target.checked })
              }
              colorScheme="blue"
              sx={{
                ".chakra-checkbox__control": {
                  borderColor: "blue.600",
                  boxShadow: "0 0 0 1px #2563eb",
                },
              }}
            >
              [필수]{" "}
              <Box
                as="span"
                display="inline"
                color="blue.600"
                textDecoration="underline"
                cursor="pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  window.open("/digital-content-terms", "_blank");
                }}
              >
                디지털 콘텐츠 유통 약관
              </Box>
              을 확인하였으며, 약관에 동의합니다.
            </Checkbox>
          </Alert>
          <Alert status="error" borderRadius="md">
            <AlertIcon />
            <Box>
              <Text>※ AI 를 활용하여 제작 된 음원은 발매가 금지됩니다.</Text>
              <Text>
                [1] 위 등록한 저작물은 AI를 활용하여 제작한 저작물이
                아니어야합니다. 인간의 창작적 기여만으로 이루어져야하며, 추후 AI
                활용이 확인되어 법적 분쟁이 발생할 경우,
              </Text>
              <Text>회원은 민형사상 법적 책임을 물을 수 있습니다.</Text>
              <Text>
                [2] 위 등록한 저작물은 2분 이상의 길이로 이루어진 저작물로 추후
                2분 미만의 곡들이 확인될 경우 발매가 보류될 수 있습니다.
              </Text>
            </Box>
          </Alert>
        </VStack>
      )}

      {/* 하단 버튼들 */}
      <Flex justify="space-between" align="center" mb={8}>
        {isDraft && (
          <Button size="sm" variant="outline" onClick={onReferralModalOpen}>
            추천인 코드를 입력해주세요
          </Button>
        )}
        <Flex justify="flex-end" flex="1">
          {isDraft && (
            <Button
              colorScheme="blue"
              onClick={handleFinalRegistration}
              isDisabled={
                !agreements.copyright ||
                !agreements.terms ||
                tracks.length === 0 ||
                !hasTitleTrack ||
                isRegistering
              }
              isLoading={isRegistering}
              loadingText="등록 중..."
              mr={4}
            >
              최종 등록
            </Button>
          )}
          {isOwned && (
            <Button colorScheme="blue" onClick={onRequestModalOpen}>
              수정 요청
            </Button>
          )}
        </Flex>
      </Flex>

      {/* 뮤지션 추가 모달 */}
      <MusicianModal
        isOpen={isMusicianModalOpen}
        onClose={() => setIsMusicianModalOpen(false)}
        onSuccess={handleMusicianAdd}
      />

      {/* 트랙 추가 모달 */}
      <TrackModal
        isOpen={isTrackModalOpen}
        onClose={() => setIsTrackModalOpen(false)}
        albumData={{ ...albumData, id, musicians }}
        onSuccess={refreshTracks}
      />

      {/* 트랙 수정 모달 */}
      {selectedTrack && (
        <TrackEditModal
          isOpen={isTrackEditModalOpen}
          onClose={() => {
            setIsTrackEditModalOpen(false);
            setSelectedTrack(null);
          }}
          track={selectedTrack}
          albumData={{ ...albumData, id, musicians }}
          tracks={tracks}
          onSuccess={() => {
            setIsTrackEditModalOpen(false);
            setSelectedTrack(null);
            refreshTracks();
          }}
        />
      )}

      {/* 추천인 코드 입력 모달 */}
      <Modal isOpen={isReferralModalOpen} onClose={onReferralModalClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>추천인 코드 입력</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl>
              <FormLabel>추천인 코드</FormLabel>
              <Input
                value={promoCode}
                onChange={(e) => setPromoCode(e.target.value)}
                placeholder="추천인 코드를 입력하세요"
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onReferralModalClose}>
              확인
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* 수정 요청 모달 */}
      <Modal isOpen={isRequestModalOpen} onClose={onRequestModalClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>수정 요청</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl mb={4}>
              <FormLabel>요청 내용</FormLabel>
              <Textarea
                value={requestContent}
                onChange={(e) => setRequestContent(e.target.value)}
                placeholder="수정 요청 내용을 입력하세요"
              />
            </FormControl>
            <FormControl>
              <FormLabel>첨부 파일</FormLabel>
              <Input
                type="file"
                onChange={(e) => setRequestFile(e.target.files[0])}
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={handleRequestSubmit}
              isDisabled={!requestContent.trim()}
            >
              요청하기
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Container>
  );
};

export default AlbumDetail;
